import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createPage } from "../../api/apiPages";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useCreatePage = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";

    const { mutate: createPageMutate, isLoading, isPending } = useMutation({
        mutationFn: createPage,
        onSuccess: () => {
            queryClient.invalidateQueries(['pages']);
            toast.success(isArabic ? "تم إنشاء الصفحة بنجاح" : "Page created successfully");
        },
        onError: (error) => {
            console.error("🚀 ~ useCreatePage ~ error:", error);
            toast.error(isArabic ? "حدث خطأ أثناء إنشاء الصفحة" : "Error creating page");
        },
    });

    return { createPageMutate, isLoading: isLoading || isPending };
};
